import { RadioGroupItem } from "@volca/ui/components/ui/radio-group";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { RerunScope } from "./rerun-scope";

export const ScopeOption = ({
  value,
  title,
  detail,
}: {
  value: RerunScope;
  title: string;
  detail: string;
}) => (
  <Stack className="w-full" direction="row" align="start" gap={2}>
    <RadioGroupItem
      value={value}
      id={`rerun-scope-${value}`}
      className="mt-1"
    />
    <label htmlFor={`rerun-scope-${value}`} className="cursor-pointer">
      <Stack align="start" gap={0}>
        <Text>{title}</Text>
        <Text variant="caption" tone="muted">
          {detail}
        </Text>
      </Stack>
    </label>
  </Stack>
);
